export default "__VITE_ASSET__0e3738e0__"